import AgeConfirmModal from "./components/AgeConfirmModal";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import ModelGrid from "./components/ModelGrid";
import FeaturesSection from "./components/FeaturesSection";
import UrgencyBar from "./components/UrgencyBar";
import DownloadCTA from "./components/DownloadCTA";
import ScrollReveal from "./components/ScrollReveal";
import ParticleBackground from "./components/ParticleBackground";
import { motion } from "framer-motion";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <ParticleBackground />
      <AgeConfirmModal onConfirm={() => {}} />
      <Header />
      <main className="relative z-10 mx-auto w-full max-w-lg pb-20">
        <ScrollReveal>
          <HeroSection />
        </ScrollReveal>
        <ScrollReveal delay={0.1}>
          <StatsSection />
        </ScrollReveal>
        <ScrollReveal delay={0.15}>
          <ModelGrid />
        </ScrollReveal>
        <ScrollReveal delay={0.1}>
          <FeaturesSection />
        </ScrollReveal>
        <ScrollReveal delay={0.1}>
          <UrgencyBar />
        </ScrollReveal>
        <ScrollReveal delay={0.15} direction="up">
          <DownloadCTA />
        </ScrollReveal>
      </main>

      {/* Floating CTA for mobile */}
      <motion.div
        className="fixed bottom-0 left-0 right-0 z-40 border-t border-background-200/50 bg-background-50/95 px-4 py-3 backdrop-blur-md md:hidden"
        initial={{ y: 80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.4, ease: [0.25, 0.4, 0.25, 1] }}
      >
        <a
          href="#download"
          className="flex w-full items-center justify-center gap-2 rounded-xl bg-primary-500 py-3 text-sm font-bold text-white transition-colors hover:bg-primary-600"
        >
          <i className="ri-download-line" />
          アプリを今すぐダウンロード
        </a>
      </motion.div>
    </div>
  );
}